import { SITE_URL, SITE_NAME, SITE_LOGO_URL } from '@/lib/site';

export default function HomeSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SITE_URL,
        description:
          'Explore the USFans Spreadsheet resource hub for product research, shipping, warehouse, coupon and safety guides. Find, compare and understand USFans resources faster.',
        inLanguage: 'en',
      },
      {
        '@type': 'Organization',
        name: SITE_NAME,
        url: SITE_URL,
        logo: {
          '@type': 'ImageObject',
          url: SITE_LOGO_URL,
        },
      },
    ],
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}